import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { RouteInfoBase } from './RouteInfo'

import { busesSelector, driversSelector } from 'reduxModules/selectors/GlobalSelectors'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import {
  busQtySelector,
  routeIdSelector,
  busNumberSelector,
  isDisabledSelector,
  firstDriverSelector,
  secondDriverSelector,
  carrierLabelSelector,
  infoForDriversSelector,
  carriagePhonesSelector,
  infoForPartnersSelector
} from 'reduxModules/selectors/RouteSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'
import { globalActions } from 'reduxModules/actions/GlobalActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  buses: busesSelector,
  busQty: busQtySelector,
  drivers: driversSelector,
  routeId: routeIdSelector,
  busNumber: busNumberSelector,
  isPartner: isPartnerSelector,
  isDisabled: isDisabledSelector,
  firstDriver: firstDriverSelector,
  secondDriver: secondDriverSelector,
  carrierLabel: carrierLabelSelector,
  infoForDrivers: infoForDriversSelector,
  carriagePhones: carriagePhonesSelector,
  infoForPartners: infoForPartnersSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
})

const mapDispatchToProps = {
  getBuses: globalActions.getBuses,
  getDrivers: globalActions.getDrivers,
  getCarriers: globalActions.getCarriers,
  setRouteInfo: routeActions.setRouteInfo,
  changeRouteInfo: routeActions.changeRouteInfo
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const RouteInfo = enhance(RouteInfoBase)



// WEBPACK FOOTER //
// ./src/components/RouteInfo/index.js